/* eslint-disable @typescript-eslint/no-explicit-any */
import { t } from "i18next";
import { ProductsFieldForForms } from "modules/products";
import { convertProductSetDetailsToListItem } from "modules/productSets";
import { useMemo } from "react";
import { Modal } from "ui";

import { NotificationProductsModalProps } from "./NotificationProductsModal.types";

import styles from "./NotificationProductsModal.module.scss";

const NotificationProductsModal = ({
  isOpen,
  onClose,
  openedNotification
}: NotificationProductsModalProps) => {
  const productsList = useMemo(
    () =>
      openedNotification.redirection?.productVariants.map(
        (variant) => variant.variant
      ),
    [openedNotification]
  );

  const productSet = useMemo(
    () =>
      convertProductSetDetailsToListItem(
        openedNotification.redirection?.productSet
      ),
    [openedNotification]
  );

  return (
    <Modal
      title={t("Notification products")}
      isOpen={isOpen}
      onClose={onClose}
      footer={<></>}
      contentClassName={styles.content}
    >
      <ProductsFieldForForms
        productsList={productsList ?? []}
        productSet={productSet}
      />
    </Modal>
  );
};

export default NotificationProductsModal;
